import * as React from 'react';

import  { Breakpoints } from '../theme';

import { createBreakpointComponent } from './BreakpointComponent';

export const Tablet = createBreakpointComponent('Tablet', Breakpoints.tablet);
